interface IPhotoPlaceholderProps {
  size?: number;
  className?: string;
}

export default function PhotoPlaceholderIcon({ size = 88, className = '' }: IPhotoPlaceholderProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3250_1103)">
        <path
          d="M51.6457 14.6124L21.9029 18.533C19.439 18.8578 17.7048 21.1185 18.0296 23.5825L21.1661 47.3767C21.4909 49.8406 23.7516 51.5748 26.2156 51.25L55.9583 47.3294C58.4222 47.0046 60.1564 44.7439 59.8316 42.2799L56.6951 18.4858C56.3704 16.0218 54.1096 14.2876 51.6457 14.6124Z"
          fill="#1C1F1F"
        />
        <path
          d="M51.6457 14.6124L21.9029 18.533C19.439 18.8578 17.7048 21.1185 18.0296 23.5825L21.1661 47.3767C21.4909 49.8406 23.7516 51.5748 26.2156 51.25L55.9583 47.3294C58.4222 47.0046 60.1564 44.7439 59.8316 42.2799L56.6951 18.4858C56.3704 16.0218 54.1096 14.2876 51.6457 14.6124Z"
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M51.6457 14.6124L21.9029 18.533C19.439 18.8578 17.7048 21.1185 18.0296 23.5825L21.1661 47.3767C21.4909 49.8406 23.7516 51.5748 26.2156 51.25L55.9583 47.3294C58.4222 47.0046 60.1564 44.7439 59.8316 42.2799L56.6951 18.4858C56.3704 16.0218 54.1096 14.2876 51.6457 14.6124Z"
          stroke="black"
          strokeOpacity="0.3"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M45.7783 27.4901C47.4209 27.2736 48.577 25.7664 48.3605 24.1238C48.144 22.4811 46.6368 21.325 44.9942 21.5415C43.3515 21.7581 42.1954 23.2652 42.412 24.9079C42.6285 26.5505 44.1356 27.7066 45.7783 27.4901Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M45.7783 27.4901C47.4209 27.2736 48.577 25.7664 48.3605 24.1238C48.144 22.4811 46.6368 21.325 44.9942 21.5415C43.3515 21.7581 42.1954 23.2652 42.412 24.9079C42.6285 26.5505 44.1356 27.7066 45.7783 27.4901Z"
          stroke="black"
          strokeOpacity="0.3"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M44.3696 39.7584L34.8344 32.4585C34.2275 31.9931 33.4658 31.777 32.705 31.8545C31.9441 31.9319 31.2416 32.297 30.7409 32.8751L20.774 44.4015M38.1126 49.6809L48.0655 36.7058C48.5205 36.1114 49.1813 35.7085 49.9182 35.5764C50.655 35.4443 51.4146 35.5924 52.0479 35.9917L59.6356 40.7919"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M44.3696 39.7584L34.8344 32.4585C34.2275 31.9931 33.4658 31.777 32.705 31.8545C31.9441 31.9319 31.2416 32.297 30.7409 32.8751L20.774 44.4015M38.1126 49.6809L48.0655 36.7058C48.5205 36.1114 49.1813 35.7085 49.9182 35.5764C50.655 35.4443 51.4146 35.5924 52.0479 35.9917L59.6356 40.7919"
          stroke="black"
          strokeOpacity="0.3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g clipPath="url(#clip1_3250_1103)">
        <path
          d="M66.491 40.8339L36.7956 36.5694C34.3356 36.2161 32.0549 37.9239 31.7016 40.384L28.29 64.1403C27.9367 66.6003 29.6446 68.881 32.1046 69.2343L61.8 73.4988C64.26 73.852 66.5407 72.1442 66.894 69.6841L70.3056 45.9279C70.6589 43.4678 68.951 41.1872 66.491 40.8339Z"
          fill="#1C1F1F"
        />
        <path
          d="M66.491 40.8339L36.7956 36.5694C34.3356 36.2161 32.0549 37.9239 31.7016 40.384L28.29 64.1403C27.9367 66.6003 29.6446 68.881 32.1046 69.2343L61.8 73.4988C64.26 73.852 66.5407 72.1442 66.894 69.6841L70.3056 45.9279C70.6589 43.4678 68.951 41.1872 66.491 40.8339Z"
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M66.491 40.8339L36.7956 36.5694C34.3356 36.2161 32.0549 37.9239 31.7016 40.384L28.29 64.1403C27.9367 66.6003 29.6446 68.881 32.1046 69.2343L61.8 73.4988C64.26 73.852 66.5407 72.1442 66.894 69.6841L70.3056 45.9279C70.6589 43.4678 68.951 41.1872 66.491 40.8339Z"
          stroke="black"
          strokeOpacity="0.3"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M57.3613 51.6468C59.0013 51.8823 60.5217 50.7437 60.7572 49.1037C60.9928 47.4637 59.8542 45.9432 58.2142 45.7077C56.5741 45.4722 55.0537 46.6108 54.8182 48.2508C54.5827 49.8908 55.7212 51.4112 57.3613 51.6468Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M57.3613 51.6468C59.0013 51.8823 60.5217 50.7437 60.7572 49.1037C60.9928 47.4637 59.8542 45.9432 58.2142 45.7077C56.5741 45.4722 55.0537 46.6108 54.8182 48.2508C54.5827 49.8908 55.7212 51.4112 57.3613 51.6468Z"
          stroke="black"
          strokeOpacity="0.3"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M52.6888 63.0808L45.4817 53.4753C45.0232 52.8632 44.3482 52.4493 43.5948 52.3182C42.8413 52.1871 42.0662 52.3487 41.4279 52.77L28.7165 61.1734M43.9828 70.9427L57.0722 61.1407C57.671 60.6914 58.4161 60.4822 59.1612 60.5541C59.9064 60.6261 60.5977 60.974 61.0994 61.5296L67.1072 68.202"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M52.6888 63.0808L45.4817 53.4753C45.0232 52.8632 44.3482 52.4493 43.5948 52.3182C42.8413 52.1871 42.0662 52.3487 41.4279 52.77L28.7165 61.1734M43.9828 70.9427L57.0722 61.1407C57.671 60.6914 58.4161 60.4822 59.1612 60.5541C59.9064 60.6261 60.5977 60.974 61.0994 61.5296L67.1072 68.202"
          stroke="black"
          strokeOpacity="0.3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3250_1103">
          <rect width="48" height="48" fill="white" transform="translate(12 12.2734) rotate(-7.50922)" />
        </clipPath>
        <clipPath id="clip1_3250_1103">
          <rect width="48" height="48" fill="white" transform="translate(28.9531 27.8672) rotate(8.1723)" />
        </clipPath>
      </defs>
    </svg>
  );
}
